import React, { Component } from "react";
import TabItem from "./tabItem";
import authorize from '../authorization/authorize';
const AuthorizedTab = authorize()(TabItem);

class TabItemList extends Component {

    constructor(props) {

        super(props);

        this.state = { 
            selected: this.props.selectedTab
        };
    }

    selectItem(name) {
        this.setState({ selected: name });
    }

    render() {

        return (
            <ul className={this.props.cssClass ? this.props.cssClass : 'tabs-list'}>
                {
                    this.props.tabs.map((tab, index) => {
                        return (
                            tab.visible ? <AuthorizedTab
                                id={tab.routeId}
                                url={tab.url}
                                cssClass={tab.cssClass}
                                text={tab.text}
                                key={index}
                                selectItem={ (name) => this.selectItem(name) }
                                isSelected={this.state.selected == tab.name}
                                allowedPermissions={tab.allowedPermissions}/>
                                : null
                        );
                    })
                }
            </ul>
        );
    }
}

export default TabItemList;


// WEBPACK FOOTER //
// ./src/components/common/tabItemList.jsx